import React, {useState} from "react";
import ProfileContainer from "../components/ProfileContainer";
import ProfileAwardRow from "../components/ProfileAwardRow";

const MAX_LENGTH = 3;

const TalentProfileAwards = ({items = []}) => {

    const [isMoreOpen, setIsMoreOpen] = useState(false);

    const sortedAwards = TB.orderBy(items, 'display_index');

    return (
        <div id="awards" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Awards  {!!sortedAwards.length && `(${sortedAwards.length})`}</h4>

                    {!sortedAwards.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Awards Available</p>
                        </div>
                    )}

                    <div className="flex flex-col divide-y">
                        {sortedAwards?.slice(0, isMoreOpen ? sortedAwards.length : MAX_LENGTH).map(award => (
                            <ProfileAwardRow key={award.id} award={award} />
                        ))}
                    </div>

                    {sortedAwards.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsMoreOpen(!isMoreOpen)}
                            >
                                <p>{sortedAwards.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", {'rotate-180': isMoreOpen})}/>
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileAwards;